<template>
  <div>
    <el-button-group v-if="!disabled">
      <el-button type="primary" size="mini" icon="el-icon-delete" @click="del()">批量删除</el-button>
      <el-button type="primary" size="mini" icon="el-icon-plus" @click="buildRecommend()">生成推荐单</el-button>
      <el-button type="primary" size="mini" icon="el-icon-plus" @click="buildQuotation()">生成报价单</el-button>
      <el-button type="primary" size="mini" icon="el-icon-plus" @click="chooseMasterSample()">选择产品</el-button>
    </el-button-group>
    <div style="height: 20px;"></div>
    <el-table
      :data="tableData"
      ref="table"
      v-loading="loading"
      @selection-change="handleSelectionChange"
      stripe
      size="mini"
    >
      <el-table-column type="selection" align="center" header-align="center" width="50"></el-table-column>
      <el-table-column prop="deImageUrl" label="图片" align="center" width="120">
        <template slot-scope="scope">
          <img fit="cover" :src="scope.row.productImageUrl?scope.row.productImageUrl:'/image/static/img/nopic.jpg'" style="width: 90px;height: 60px;">
        </template>
      </el-table-column>
      <el-table-column  prop="productDesc" align="left" label="产品说明" min-width="260">
        <template slot-scope="scope">
          <div>{{scope.row.productNo}}</div>
          <div style="color: red;">{{scope.row.productDesc}}</div>
          <div>产品类型：{{scope.row.productTypeName}}</div>
        </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="left"
        prop="productTypeName"
        label="规格及面料"
        min-width="230"
      >
        <template slot-scope="scope">
          <div>Size：{{scope.row.productSpec}}</div>
          <div>Weight：{{scope.row.productWeight}}</div>
          <div>Component：{{scope.row.productComponentEn}}</div>
        </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="left"
        header-align="left"
        prop="factoryPrice"
        label="产品价格"
        min-width="130"
      >
        <template slot-scope="scope">
          <div>工厂价：{{scope.row.factoryPrice}}</div>
          <div>FOB价：{{scope.row.fobPrice}}</div>
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        header-align="left"
        prop="recommendStatusName"
        label="推荐情况"
        min-width="130"
      >
        <template slot-scope="scope">
          <div>
            <el-tag
              size="mini"
              :type="scope.row.recommendStatus === 'T' ? 'success' : 'danger'"
            >{{scope.row.recommendStatusName}}</el-tag>
          </div>
          <div v-if="scope.row.recommendStatus === 'T'">
            {{scope.row.recommendNo}}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        header-align="left"
        prop="choiceStatusName"
        label="客户反馈"
        min-width="100"
      >
        <template slot-scope="scope">
          <el-tag
            size="mini"
            :type="scope.row.choiceStatus === 'C' ? 'success' : scope.row.choiceStatus === 'N' ? '': 'danger'"
          >{{scope.row.choiceStatusName}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="left"
        header-align="left"
        prop="choiceDesc"
        label="客人反馈意见"
        min-width="200"
      ></el-table-column>
      <el-table-column
        align="left"
        header-align="left"
        prop="quotationStatusName"
        label="报价情况"
        min-width="130"
      >
        <template slot-scope="scope">
          <div>
            <el-tag
              size="mini"
              :type="scope.row.quotationStatus === 'Q' ? 'success' : 'danger'"
            >{{scope.row.quotationStatusName}}</el-tag>
          </div>
          <div v-if="scope.row.quotationStatus === 'Q'">
            {{scope.row.quotationNo}}
          </div>
          <div v-if="scope.row.quotationStatus === 'Q'">
            工厂价：{{scope.row.quotationCostPrice}}
          </div>
          <div v-if="scope.row.quotationStatus === 'Q'">
            FOB价：{{scope.row.quotationFobPrice}}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        header-align="left"
        prop="linkPrjStatusName"
        label="打样情况"
        min-width="130"
      >
        <template slot-scope="scope">
          <div>
            <el-tag
              size="mini"
              :type="scope.row.linkPrjStatus === 'P' ? 'success' : 'danger'"
            >{{scope.row.linkPrjStatusName}}</el-tag>
          </div>
          <div v-if="scope.row.linkPrjStatus === 'P'">
            {{scope.row.linkPrjNo}}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="left"
        header-align="left"
        prop="choiceUserName"
        label="选品人"
        min-width="200"
      >
        <template slot-scope="scope">
          <div>
            选品人：{{scope.row.choiceUserName}}
          </div>
          <div>
            选品时间：{{scope.row.choiceTime}}
          </div>
          <div>
            更新时间：{{scope.row.updateTime}}
          </div>
        </template>
      </el-table-column>
      <el-table-column v-if="!disabled" label="操作" width="200" fixed="right" header-align="center" align="left">
        <template slot-scope="scope">
          <el-button
            @click="delRow(scope.row)"
            type="text"
            size="mini"
          >删除</el-button>
          <el-button
            @click="updateCustChoice(scope.row,'C','选中')"
            type="text"
            size="mini"
            v-if="scope.row.choiceStatus === 'N'"
          >选中</el-button>
            <el-button
              @click="updateCustChoice(scope.row,'N','取消选中')"
              type="text"
              size="mini"
              v-if="scope.row.choiceStatus === 'C'"
            >取消选中</el-button>
          <el-button
            @click="buildProjectMethod(scope.row)"
            type="text"
            v-if="scope.row.linkPrjStatus === 'N'"
            size="mini"
          >生成打样项目</el-button>
        </template>
      </el-table-column>
      <div slot="empty">
        <div class="mt-60">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">暂无数据！</p>
        </div>
      </div>
    </el-table>
    <el-dialog
      ref="choiceDialog"
      title='请填写选中说明'
      :visible.sync="formOption.choiceDialogVisible"
      :before-close="cancel"
      :close-on-click-modal="false"
      width="900px"
    >
      <el-input
        type="textarea"
        @close="cancel"
        :autosize="{ minRows: 10, maxRows: 15}"
        v-model="choiceDesc"
        maxlength="450"
        clearable
        style="width: 850px"
        placeholder="请填写数据"
      ></el-input>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel" size="small">取 消</el-button>
        <el-button
          type="primary"
          @click="updateCustChoiceSave"
          size="small"
        >保 存</el-button>
      </div>
    </el-dialog>
    <BuildProject ref="buildProject" @success="buildProjectSuccess"/>
    <el-dialog
      ref="chooseMasterSampleDialog"
      title="选择产品"
      :visible.sync="formOption.masterSampleVisible"
      :before-close="masterSampleCancel"
      :close-on-click-modal="false"
      width="1000px"
    >
      <choose-master-sample ref="chooseMasterSampleForm" :params="params"></choose-master-sample>
      <div slot="footer" class="dialog-footer">
        <el-button @click="masterSampleCancel" size="small">取 消</el-button>
        <el-button type="primary" @click="addMasterSample" size="small">添 加</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import BuildProject from '../buildProject'
// import { addApi, delProjectInfoProduct, delChoiceProjectInfoProduct, productBuildRecommend, productBuildQuotation, productUpdateCustChoice } from '@api/projectManager/infoProduct'
export default {
  props: {
    tableData: {
      default: () => []
    },
    loading: {
      default: false
    },
    params: {
      default: null,
      type: Object
    },
    disabled: {
      default: true,
      type: Boolean
    }
  },
  components: {
    BuildProject,
    'ChooseMasterSample': () => import('@/components/choose-masterSample')
  },
  data () {
    return {
      // 表单设置
      formOption: {
        title: '',
        choiceDialogVisible: false,
        masterSampleVisible: false
      },
      // 选中的数据
      multipleSelection: [],
      productList: [],
      choiceDesc: '',
      rowData: {}
    }
  },
  methods: {
    handleSelectionChange (val) {
      this.multipleSelection = val
    },
    delRow (row) { // 单条数据删除
      this.$confirm('是否删除？')
        .then(_ => {
          this.$api.delInfoProductApi({ prjCode: this.params.prjCode, prjProductCode: row.prjProductCode })
            .then(res => {
              this.$message({
                showClose: true,
                message: '删除成功',
                type: 'success'
              })
              this.$emit('submit')
            })
        })
    },
    del () { // 多行数据删除
      if (!this.multipleSelection || this.multipleSelection.length < 1) {
        this.$message({
          showClose: true,
          message: '请选择需要删除的数据',
          type: 'warning'
        })
        return
      }
      this.$confirm('是否删除？')
        .then(_ => {
          this.$api.delChoiceInfoProductApi({ prjCode: this.params.prjCode, delListInfoProductCode: this.multipleSelection })
            .then(res => {
              this.$message({
                showClose: true,
                message: '删除成功',
                type: 'success'
              })
              this.$emit('submit')
            })
        })
        .catch(() => {
          this.$refs.table.clearSelection()
          this.multipleSelection = []
        })
    },
    buildRecommend () { // 生成推荐单
      if (!this.multipleSelection || this.multipleSelection.length < 1) {
        this.$message({
          showClose: true,
          message: '请选择需要生成推荐单的数据',
          type: 'warning'
        })
        return
      }
      this.$confirm('是否生成推荐单？')
        .then(_ => {
          this.$api.buildRecommendInfoProductApi({ prjCode: this.params.prjCode, delListInfoProductCode: this.multipleSelection })
            .then(res => {
              this.$message({
                showClose: true,
                message: '生成推荐单成功',
                type: 'success'
              })
              this.$emit('submit')
            })
        })
        .catch(() => {
          this.$refs.table.clearSelection()
          this.multipleSelection = []
        })
    },
    // 生成报价单
    buildQuotation () {
      let selection = this.$refs.table.selection
      if (!selection || selection.length < 1) {
        this.$message({
          showClose: true,
          message: '请选择需要生成报价单的数据',
          type: 'warning'
        })
        return
      }
      this.$confirm('是否生成报价单？')
        .then(_ => {
          this.$api.buildQuotationInfoProductApi({ prjCode: this.params.prjCode, delListInfoProductCode: selection })
            .then(res => {
              this.$message({
                showClose: true,
                message: '生成报价单成功',
                type: 'success'
              })
              this.$emit('submit')
            })
        })
        .catch(() => {
          this.$refs.table.clearSelection()
        })
    },
    updateCustChoice (row, status, text) { // 选中和取消选中
      if (text === '选中') {
        this.rowData = row
        this.formOption.choiceDialogVisible = true
      } else {
        this.$confirm('是否' + text + '？')
          .then(_ => {
            this.$api.updateCustomChoiceInfoProductApi({ prjCode: this.params.prjCode, prjProductCode: row.prjProductCode, choiceStatus: status, choiceDesc: ' ' })
              .then(res => {
                this.$message({
                  showClose: true,
                  message: text + '成功',
                  type: 'success'
                })
                this.$emit('submit')
              })
          })
          .catch(() => {
            this.$refs.table.clearSelection()
            this.choiceDesc = ''
          })
      }
    },
    updateCustChoiceSave () { // 选中后填写选中说明保存
      this.$api.updateCustomChoiceInfoProductApi({ prjCode: this.params.prjCode, prjProductCode: this.rowData.prjProductCode, choiceStatus: 'C', choiceDesc: this.choiceDesc })
        .then(res => {
          this.$message({
            showClose: true,
            message: '选中成功',
            type: 'success'
          })
          this.cancel()
          this.$emit('submit')
        })
    },
    cancel () {
      this.choiceDesc = ''
      this.rowData = {}
      this.formOption.choiceDialogVisible = false
    },
    masterSampleCancel () { // 取消选品弹框
      this.formOption.masterSampleVisible = false
      this.productList = []
    },
    chooseMasterSample () { // 显示选品弹框
      this.formOption.masterSampleVisible = true
      setTimeout(() => {
        // 调用组件表单加载方法
        this.$refs.chooseMasterSampleForm.load()
      }, 0)
    },
    addMasterSample () { // 保存勾选的选品
      let data = this.$refs.chooseMasterSampleForm.selected
      if (!data || data.length < 1) {
        this.$message({
          showClose: true,
          message: '请选择数据',
          type: 'warning'
        })
        return
      }
      for (let i = 0; i < data.length; i++) {
        let newData = {
          productType: 'S',
          productCode: data[i].sampleCode
        }
        this.productList.push(newData)
      }
      let params = {
        prjCode: this.params.prjCode,
        productList: this.productList
      }
      this.$api.addInfoProductApi(params).then(res => {
        this.$message({
          showClose: true,
          message: '添加成功',
          type: 'success'
        })
        this.masterSampleCancel()
        this.$emit('submit')
      })
    },
    buildProjectMethod (row) {
      this.$refs.buildProject.load(this.params.prjCode, row.prjProductCode)
    },
    buildProjectSuccess () {
      this.$emit('submit')
    }
  }
}
</script>
